/**
 * Utility functions for managing Awin affiliate tracking cookies
 */

/**
 * List of Awin cookie names to clear
 * _aw_sn_59359: Awin session cookie
 * _aw_j_59359: Awin joiner/affiliate ID cookie
 */
const AWIN_COOKIE_NAMES = ["_aw_sn_59359", "_aw_j_59359"];

/**
 * Clears Awin cookies if the current hostname is my.evvy.com.
 * This ensures affiliate sales are not attributed to orders from the internal site.
 */
export const clearAwinCookiesForInternalSite = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  const hostname = window.location.hostname;

  // Clear cookies only on my.evvy.com
  if (hostname === "my.evvy.com") {
    _clearAwinCookies();
  }
};

/**
 * Clears Awin tracking cookies by setting their expiration to a past date.
 * This prevents affiliate attribution for sales originating from internal sites.
 *
 * @param domain - The domain to clear cookies for (e.g., '.evvy.com')
 */
const _clearAwinCookies = (domain: string = ".evvy.com"): void => {
  const pastDate = new Date(0).toUTCString();

  AWIN_COOKIE_NAMES.forEach((cookieName) => {
    // Clear cookie for the specified domain
    document.cookie = `${cookieName}=; expires=${pastDate}; path=/; domain=${domain}`;

    // Also clear for the current hostname (in case it's set without domain)
    document.cookie = `${cookieName}=; expires=${pastDate}; path=/;`;
  });
};
